// extracted by mini-css-extract-plugin
module.exports = {"animationB":"animationB_animationB__7dd0e"};